import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Config} from "../../config/config";
import {
  LoadingCircularSpinnerComponent
} from "../../shared/components/loading-circular-spinner/loading-circular-spinner.component";
import {NgClass, NgIf} from "@angular/common";
import {DbTextPipe} from "../../shared/pipes/db-text.pipe";

@Component({
    selector: 'db-google-auth',
    templateUrl: './google-auth.component.html',
    styleUrls: ['./google-auth.component.scss'],
    imports: [
        LoadingCircularSpinnerComponent,
        NgIf,
        NgClass,
        DbTextPipe
    ]
})
export class GoogleAuthComponent implements OnInit, OnChanges {

  @Output() verifyGoogleToken = new EventEmitter<any>();
  @Input () loading: boolean;
  @Input () size: string;
  @Input () color: string;
  @Input () googleClientId: string;

  constructor(
  ) {
  }

  ngOnInit(): void {
    if (this.googleClientId) {
      this.initializeGoogleSignIn();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['googleClientId'] && !changes['googleClientId'].firstChange && changes['googleClientId'].currentValue) {
      this.initializeGoogleSignIn();
    }
  }

  // Google login callback function
  googleLoginCallback(response: any) {
    this.verifyGoogleToken.emit(response.credential);
  }

  initializeGoogleSignIn() {
    window['google'] && window['google'].accounts.id.initialize({
      client_id: this.googleClientId,
      callback: (response: any) => this.googleLoginCallback(response),
      auto_select: false,
      allowed_parent_origin: window.location.origin,
    });
    window['google'] && window['google'].accounts.id.renderButton(
      document.querySelector('.g_id_signin'),
      { theme: 'outline', size: 'large', logo_alignment: "center", width: '260', text: 'signup_with', locale: 'en_US' }
    );

    window['google'] && window['google'].accounts.id.prompt();
  }

  // Create a hidden Google Sign-In button
  createFakeGoogleButton() {
    const googleLoginWrapper = document.createElement('div');
    googleLoginWrapper.style.display = 'none';
    document.body.appendChild(googleLoginWrapper);

    window['google'] && window['google'].accounts.id.renderButton(googleLoginWrapper, {
      type: 'icon',
      width: '200',
    });

    return googleLoginWrapper.querySelector('div[role=button]') as HTMLElement;
  }

  // Trigger Google login flow
  onGoogleLoginClick() {
    const googleButton = this.createFakeGoogleButton();
    googleButton?.click();
  }
}
